import * as React from "react";

import style from "./pathTooltip.scss";
import Tooltip from "components/tooltip/Tooltip";

// 350px maxWidth here is matched to 400px $selectWidth in
// create-report-view-modal.scss. That is, tooltip should be at most a
// little less wide than the dropdown or table. If it's wider, it'll
// create a horizontal scrollbar.

// Delay is 300 because the default value zero results in constant new
// tooltip popups when you're scrolling through columns in available
// columns dropdown. Default delay value for hiding the tooltip has also
// been adjusted because the default value 500 merely meant that there
// could be multiple visible tooltips at the same time.

// Auto placement seems to work fairly well. Normally we show the tooltip
// on top of the item but then it covers the previous column completely.
// "Auto" strategy still does that if the tooltip is long enough but in
// some cases it can show the tooltip on the right side of the visible
// value. That's the best case because it's not in the way.

// TODO BCC-2571 Use full path.
const TOOLTIP_MAX_WIDTH = 350;
const TOOLTIP_DELAY: [number, number] = [300, 0];

export function createPathTooltip(visibleText: string, tooltipText: string, testId: string): JSX.Element {
    return (
        <Tooltip content={tooltipText} maxWidth={TOOLTIP_MAX_WIDTH} delay={TOOLTIP_DELAY} placement={"auto"}>
            <span data-testid={testId} data-path={tooltipText} className={style.pathTooltip}>
                {visibleText}
            </span>
        </Tooltip>
    );
}
